import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { SuggestedParty } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class SuggestedPartiesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getForParty(partyId: string): Observable<SuggestedParty[]> {
        return this.http.get<SuggestedParty[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/party/${partyId}/suggestedparties`,
        );
    }
}
